export default __webpack_public_path__ + "static/media/sd_toggle_on.836e3487.svg";